const landingUrls = {
    ED: {
        AR: 'https://www.edreams.com.ar/merch/app/',
        AU: 'https://www.edreams.com.au/app/',
        en_CA: 'https://ca.edreams.com/merch/app/',
        fr_CA: 'https://ca.edreams.com/fr/merch/app/',
        de_CH: 'https://www.edreams.ch/merch/app/',
        fr_CH: 'https://www.edreams.ch/fr/merch/app/',
        it_CH: 'https://www.edreams.ch/it/merch/app/',
        CL: 'https://cl.edreams.com/merch/app/',
        CO: 'https://www.edreams.com.co/merch/app/',
        DE: 'https://www.edreams.de/merch/app/',
        ES: 'https://www.edreams.es/como-funciona/app/',
        FR: 'https://www.edreams.fr/comment-ca-marche/app/',
        GB: 'https://www.edreams.com/app/',
        GR: 'https://www.edreams.gr/merch/app/',
        HK: 'https://edreams.com.hk/merch/app/',
        HU: 'https://www.edreams.hu/merch/app/',
        ID: 'https://id.edreams.com/merch/app/',
        IN: 'https://www.edreams.in/merch/app/',
        IT: 'https://www.edreams.it/come-funziona/app/',
        JP: 'https://www.edreams.jp/merch/app/',
        en_KR: 'https://www.edreams.co.kr/en/merch/app/',
        MA: 'https://www.edreams.ma/merch/app/',
        MX: 'https://www.edreams.com.mx/merch/app/',
        MY: 'https://www.edreams.my/merch/app/',
        NL: 'https://nl.edreams.com/merch/app/',
        NZ: 'https://nz.edreams.com/merch/app/',
        PH: 'https://edreams.ph/merch/app/',
        PT: 'https://www.edreams.pt/como-funciona/app/',
        QA: 'https://www.edreams.qa/merch/app/',
        RU: 'https://www.edreams.com.ru/merch/app/',
        en_SA: 'https://www.edreams.sa/en/merch/app/',
        SG: 'https://sg.edreams.com/merch/app/',
        TH: 'https://th.edreams.com/merch/app/',
        TR: 'https://www.edreams.com.tr/merch/app/',
        TW: 'https://www.edreams.tw/merch/app/',
        UK: 'https://www.edreams.co.uk/how-it-works/app/',
        en_US: 'https://www.edreams.net/app/',
        es_US: 'https://www.edreams.net/es/merch/app/',
        ZA: 'https://za.edreams.com/merch/app/',
        default: 'https://www.edreams.com/app/',
    },
    OP: {
        AE: 'http://ae.opodo.com/merch/app/',
        de_CH: 'https://www.opodo.ch/merch/app/',
        fr_CH: 'https://www.opodo.ch/fr/merch/app/',
        it_CH: 'https://www.opodo.ch/it/merch/app/',
        DE: 'https://www.opodo.de/app/',
        DK: 'https://www.opodo.dk/merch/app/',
        FI: 'https://www.opodo.fi/merch/app/',
        FR: 'https://www.opodo.fr/app-vacances/',
        GB: 'https://www.opodo.com/mobile-app/',
        IT: 'https://www.opodo.it/merch/app/',
        NL: 'https://www.opodo.nl/merch/app/',
        NO: 'https://www.opodo.no/merch/app/',
        PL: 'https://www.opodo.pl/merch/app/',
        SE: 'https://www.opodo.se/merch/app/',
        UK: 'https://www.opodo.co.uk/app/',
        default: 'https://www.opodo.com/mobile-app/',
    },
    GO: {
        FR: 'https://www.govoyages.com/application-voyage/',
        default: 'https://www.govoyages.com/application-voyage/',
    },
};

const localeExceptionsList = [
    'en_CA',
    'fr_CA',
    'de_CH',
    'fr_CH',
    'it_CH',
    'en_KR',
    'en_SA',
    'en_US',
    'es_US',
];

module.exports = function({brandNewNomenclature, website, locale}) {
    const landingUrl = localeExceptionsList.includes(locale)
        ? landingUrls[brandNewNomenclature][locale]
        : landingUrls[brandNewNomenclature][website];

    return landingUrl ? landingUrl : landingUrls[brandNewNomenclature].default;
};
